import type { GraphFilters } from './GraphView';
import './GraphFilters.css';

interface Props {
  value: GraphFilters;
  onChange: (next: GraphFilters) => void;
}

const MODES = [
  { id: 'all', label: 'All' },
  { id: 'mature', label: 'Mature' },
  { id: 'emergent', label: 'Emergent' },
] as const;

export function GraphFiltersBar({ value, onChange }: Props) {
  return (
    <div className="graph-filters">
      {MODES.map((mode) => (
        <button
          key={mode.id}
          type="button"
          onClick={() => onChange({ ...value, mode: mode.id })}
          className={`graph-filters__chip${value.mode === mode.id ? ' graph-filters__chip--active' : ''}`}
        >
          {mode.label.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
